import { createKickGesture } from './kickFactory.js';
export default createKickGesture('right');
